import React, { PropTypes, Component } from 'react';
import Paper from 'material-ui/Paper';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import moment from 'moment';
import { fileUrls } from '../../api.js';
import ActivityWithIcon from '../contracting/generic-components/activity-with-icon';
import injectSheet from 'react-jss';

const styles = {
  note: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'wrap',
    '&.disabled': {
      pointerEvents: 'none',
      opacity: '0.4',
      cursor: 'progress',
    },
  },
  menuAndMessage: {
    flexGrow: '1',
    display: 'flex',
    justifyContent: 'flex-end',
  },
  iconMenu: {
    '& > button': {
      padding: '0 !important',
      width: 'auto !important',
    },
  },
  moreVertIcon: {
    width: '20px !important',
    height: '20px !important',
    color: 'rgba(0, 0, 0, 0.54) !important',
  },
  menutText: {
    fontSize: '0.9em !important',
    lineHeight: '2em !important',
    minHeight: '2em !important',
  },
  item: {
    overflowX: 'hidden',
    overflowY: 'auto',
    margin: '0.5em',
    padding: '0.5em',
    backgroundColor: '#FFF5EA !important',
    overflowWrap: 'break-word',
    wordWrap: 'break-word',
    '-webkit-hyphens': 'auto',
    '-ms-hyphens': 'auto',
    '-moz-hyphens': 'auto',
    hyphens: 'auto',
  },
  noteFooter: {
    width: '100%',
    textAlign: 'right',
    margin: '0 0.5em 1em',
    color: 'rgba(0, 0, 0, 0.54) !important',
    fontSize: '12px',
  },
  fileAttachment: {
    marginTop: '10px',
  },
  noteContent: {
    fontSize: '14px',
    whiteSpace: 'pre-wrap',
  },
};

class NoteContent extends Component {
  render() {
    const { classes, itemId, bodyText, bodyJson, attachments, authorname, timestamp, handleRemove, handleAddToContract, disallowAddToContract, disabled } = this.props;
    return (
      <div className={`${classes.note}${disabled ? ' disabled' : ''}`} key={itemId} >
        <div className={classes.menuAndMessage}>
          <IconMenu
            className={classes.iconMenu}
            iconButtonElement={<IconButton><MoreVertIcon className={classes.moreVertIcon} /></IconButton>}
            anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
            targetOrigin={{ horizontal: 'left', vertical: 'top' }}
          >
            <MenuItem primaryText="Remove" className={classes.menutText} onTouchTap={() => handleRemove(this.props.itemId)}/>
            { (attachments.length > 0 && !disallowAddToContract) ?
              <MenuItem primaryText="Add files to contract" className={classes.menutText} onTouchTap={() => handleAddToContract(this.props.itemId)}/>
            : undefined}
          </IconMenu>
          <Paper className={classes.item}>
            <span className={classes.noteContent}>
              {bodyText}
              {(attachments || []).map((file, ix) => <ActivityWithIcon
                className={classes.fileAttachment}
                file={{ downloadUrl: file.downloadUrl || fileUrls.getDownloadUrlSync(file.path), fileName: file.name }}
                key={ix}
              />)}
            </span>
          </Paper>
        </div>
        <div className={classes.noteFooter}>by {authorname} {moment(new Date(timestamp)).fromNow()}{(bodyJson && bodyJson.addedToContract ? ', files added to Contract' : '')}</div>
      </div>
    );
  }
}

NoteContent.propTypes = {
  attachments: PropTypes.array,
  authorname: PropTypes.string,
  bodyJson: PropTypes.object,
  bodyText: PropTypes.string,
  classes: PropTypes.object,
  handleAddToContract: PropTypes.func,
  handleRemove: PropTypes.func,
  itemId: PropTypes.string,
  timestamp: PropTypes.string,
  disallowAddToContract: PropTypes.bool,
  disabled: PropTypes.bool,
};

NoteContent.defaultProps = {
  handleAddToContract: key => console.log(key),
  bodyJson: {},
  disallowAddToContract: false,
  disabled: false,
};

export default injectSheet(styles)(NoteContent);



// WEBPACK FOOTER //
// ./src/app/components/notes/note-content.jsx